<template>
  <div class="Exporthk7">
    <v-row>
      <v-col class="text-right">
        <!-- <v-btn
          type="button"
          @click="
            exportexcelhk7(
              tokenexport,
              exportthn,
              exportbln,
              exportps,
              paparnegeriexport
            )
          "
          color="blue white white--text"
        >
          <span class="material-icons">file_download</span>
          {{ $t("muatturun") }} {{ $t("hk7") }}
        </v-btn> -->
         <download-excel
              :data = "papardatahk7"
              type="csv"
              name="hk7.xls"
              >
              <v-btn type="button" color="blue white white--text">
                <span class="material-icons">file_download</span>
                {{ $t("muatturun") }} {{ $t("hk7") }}
              </v-btn>
            </download-excel>
      </v-col>
    </v-row>
    &nbsp;
    <v-row>
      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="papardatahk7"
          :items-per-page="10"
          class="elevation-1"
          height="500"
          fixed-header
        >
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
// import i18n from "@/i18n";
// import hidServices from "@/services/lookupField";
// const lookup = new hidServices();
import axios from "../../plugins/axios";
import Vue from 'vue';
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  Name: "Exporthk7",
  setup() {},
  props: [
    "papardatahk7",
    "exportthn",
    "exportbln",
    "exportps",
    "paparnegeriexport",
  ],
  mounted() {},
  data: () => ({
    tokenexport: window.localStorage.getItem("tokenexport"),
    databatch: "",
    headers: [
      {text: "Bil", value: "Bil"},
      {text: "HID", value: "HID"},
      {text: "BNO", value: "BNO"},
      {text: "Pusingan", value: "Pusingan"},
      {text: "S", value: "S"},
      {text: "NG", value: "NG"},
      {text: "DP", value: "DP"},
      {text: "DB", value: "DB"},
      {text: "BP", value: "BP"},
      {text: "ST", value: "ST"},
      {text: "NOIR", value: "NOIR"},
      {text: "NOAIR", value: "NOAIR"},
      // {text: "KAW", value: "KAW"},
      // {text: "P", value: "P"},
      // {text: "Bulan", value: "Bulan"},
      // {text: "Tahun", value: "Tahun"},
      {text: "Sayur_tahun", value: "Sayur_tahun"},
      {text: "Kelapa_tahun", value: "Kelapa_tahun"},
      {text: "Ikan_tahun", value: "Ikan_tahun"},
      {text: "Ayam_tahun", value: "Ayam_tahun"},
      {text: "Itik_tahun", value: "Itik_tahun"},
      {text: "Telur_tahun", value: "Telur_tahun"},
      {text: "Rambutan_tahun", value: "Rambutan_tahun"},
      {text: "Durian_tahun", value: "Durian_tahun"},
      {text: "Pisang_tahun", value: "Pisang_tahun"},
      {text: "KayuApi_tahun", value: "KayuApi_tahun"},
      {text: "LL_tahun", value: "LL_tahun"},
      {text: "LL1_tahun", value: "LL1_tahun"},
      {text: "LLD_tahun", value: "LLD_tahun"},
      {text: "LLD1_tahun", value: "LLD1_tahun"},
      {text: "LLD2_tahun", value: "LLD2_tahun"},
      {text: "LLD3_tahun", value: "LLD3_tahun"},
      {text: "INCS21KS", value: "INCS21KS"},
    ],
  }),
  methods: {
    async exportexcelhk7(
      tokenexport,
      exportthn,
      exportbln,
      exportps,
      paparnegeriexport
    ) {
      try {
        await axios
          .post(`${process.env.VUE_APP_API_URL}/sec/checksession`, {
            tokenexportsess: window.localStorage.getItem("tokenexport"),
          })
          .then((result) => {
            console.log(result.data.status);
            if (result.data.status) {
              window.open(
                `${process.env.VUE_APP_API_URL}/HK/exporthk7serverside/${tokenexport}/${exportthn}/${exportbln}/${exportps}/${paparnegeriexport}/`,
                "_blank"
              );
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>